import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const textFieldStyle = {
    width: '100%'
};

class InputTitleInterest extends Component {
    state = {
        value: this.props.value !== undefined ? this.props.value : ''
    };

    componentWillReceiveProps({ value }) {
        if (value !== this.props.value) {
            this.setState({ value });
        }
    }

    handleChange = ({ target }) => {
        this.setState({
            value: target.value
        });
    };

    render() {
        return (
            <TextField
                floatingLabelText="Interest Name"
                value={this.state.value}
                style={textFieldStyle}
                onChange={this.handleChange}
                onBlur={this.props.onSave}
            />
        );
    }
}

InputTitleInterest.defaultProps = { value: '' };

InputTitleInterest.propTypes = {
    value: PropTypes.string,
    onSave: PropTypes.func.isRequired
};

export default InputTitleInterest;



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/AddInterestFormDialog/InputTitleInterest.js
 **/